<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/config/orderNumber/rule/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('danjumingcheng')">
            <yi_dictionary_select :type="'DOCUMENT_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_system_order_create')" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_system_order_rule_update')" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('danjumingcheng')" required>
            <yi_dictionary_select :type="'DOCUMENT_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('qianzhui')" required>
            <el-input v-model="yt.editObj.prefix"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shijiangeshi')" required>
            <el-select :popper-append-to-body="false" filterable :clearable="true" v-model="yt.editObj.dateTimeFormat">
              <el-option v-for="item in timeFormatList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zizengweishu')" required>
            <el-input v-model="yt.editObj.increment"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suijiweishu')" required>
            <el-input v-model="yt.editObj.random"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.enable">
              <el-option v-for="(item, index) in status" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/config/orderNumber/rule/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('danjumingcheng')" required class="noborder">
            <yi_dictionary_select disabled :type="'DOCUMENT_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('qianzhui')" required>
            <el-input v-model="yt.editObj.prefix"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shijiangeshi')" required>
            <el-select :popper-append-to-body="false" filterable :clearable="true" v-model="yt.editObj.dateTimeFormat">
              <el-option v-for="item in timeFormatList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zizengweishu')" required>
            <el-input v-model="yt.editObj.increment"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suijiweishu')" required>
            <el-input v-model="yt.editObj.random"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.enable">
              <el-option v-for="(item, index) in status" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/config/orderNumber/rule/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_system_order_rule_list',
  data() {
    return {
      dictionaryList: [],
      timeFormatList: [
        {
          value: 'yyyyMMdd',
          label: 'yyyyMMdd'
        },
        {
          value: 'yyyyMM',
          label: 'yyyyMM'
        }
      ],
      status: [
        {
          label: this.$t('shi'),
          value: true
        },
        {
          label: this.$t('fou'),
          value: false
        }
      ],
      list: [],
      rolesList: [],
      organizationList: [],
      columns: [
        {
          label: 'danjubianma',
          prop: 'code'
        },
        {
          label: 'danjumingcheng',
          type: 'dictionary',
          key: 'DOCUMENT_TYPE',
          prop: 'type',
          width: 150
        },
        {
          label: 'kehubianma',
          prop: 'customerCode'
        },
        {
          label: 'kehumingcheng',
          prop: 'customerName'
        },
        {
          label: 'qianzhui',
          prop: 'prefix'
        },
        {
          label: 'shijiangeshi',
          prop: 'dateTimeFormat'
        },
        {
          label: 'zizengweishu',
          prop: 'increment'
        },
        {
          label: 'suijiweishu',
          prop: 'random'
        },
        {
          label: 'shifouqiyong',
          prop: 'enable',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'beizhu',
          prop: 'remarks'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 100,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.getDictCatList();
    }, 300);
  },

  methods: {
    async getDictCatList() {
      let response = await this.http.get('/web/config/dictType/page', {
        params: {
          pageNum: 1,
          pageSize: 100
        }
      });
      this.dictionaryList = response.data.rows;
    }
  }
};
</script>
